const FETCHING_EXTRANET_URL = 'FETCHING_EXTRANET_URL';
const FETCH_EXTRANET_URL_SUCCESS = 'FETCH_EXTRANET_URL_SUCCESS';
const FETCH_EXTRANET_URL_FAIL = 'FETCH_EXTRANET_URL_FAIL';

const fetchingExtranetUrl = () => {
  return {
    type: FETCHING_EXTRANET_URL
  };
};

const fetchExtranetUrlSuccess = () => {
  return {
    type: FETCH_EXTRANET_URL_SUCCESS
  };
};

const fetchExtranetUrlFailed = err => {
  return {
    type: FETCH_EXTRANET_URL_FAIL,
    payload: err
  };
};

export {
  fetchingExtranetUrl,
  fetchExtranetUrlSuccess,
  fetchExtranetUrlFailed,
  FETCHING_EXTRANET_URL,
  FETCH_EXTRANET_URL_SUCCESS,
  FETCH_EXTRANET_URL_FAIL
};
